import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Button,
  Box,
  CircularProgress,
} from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

export const SubmitDialog = ({ open, onConfirm, onCancel, isSubmitting, t }) => (
  <Dialog open={open} onClose={isSubmitting ? undefined : onCancel} PaperProps={{ sx: { borderRadius: 2, p: 1 } }}>
    <DialogTitle sx={{ fontWeight: 700 }}>{t.submitDialogTitle}</DialogTitle>
    <DialogContent>
      <Box
        sx={{
          display: "flex",
          gap: 1.5,
          p: 2,
          mb: 2,
          backgroundColor: "#f0fdf4",
          border: "1px solid #bbf7d0",
          borderRadius: 2,
          alignItems: "flex-start",
        }}
      >
        <LockOutlinedIcon sx={{ color: "#16a34a", fontSize: 20, mt: 0.25, flexShrink: 0 }} />
        <DialogContentText sx={{ color: "#15803d", fontSize: "0.875rem", m: 0 }}>
          {t.submitInstructions}
        </DialogContentText>
      </Box>
      <DialogContentText>{t.submitDialogMessage}</DialogContentText>
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 2.5, gap: 1 }}>
      <Button
        onClick={onCancel}
        variant="outlined"
        disabled={isSubmitting}
        sx={{ borderRadius: 1.5, borderColor: "#163666", color: "#163666" }}
      >
        {t.cancel}
      </Button>
      <Button
        onClick={onConfirm}
        variant="contained"
        disabled={isSubmitting}
        autoFocus
        sx={{ borderRadius: 1.5, backgroundColor: "#163666", minWidth: 100 }}
      >
        {isSubmitting
          ? <CircularProgress size={18} sx={{ color: "#fff" }} />
          : <span>{t.submit}</span>}
      </Button>
    </DialogActions>
  </Dialog>
);
